import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllInvoicesQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  customer?: Types.InputMaybe<Types.Scalars['Float']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllInvoicesQuery = { __typename?: 'Query', allInvoices?: { __typename?: 'InvoiceNodeConnection', edges: Array<{ __typename?: 'InvoiceNodeEdge', cursor: string, node?: { __typename?: 'InvoiceNode', id: string, customerName?: string | null, phone?: string | null, currency: Types.PaymentInvoiceCurrencyChoices, vatRate: number, vatPrice: number, vatIndexPriceDiff?: number | null, idAsString?: string | null, totalPrice: number, notes?: string | null, chargedIndex: number, chargeDate?: any | null, baseRentalPrice?: number | null, baseLicenceAndInsurancePrice?: number | null, baseMaintenancePrice?: number | null, dealIds?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null, hasPreviousPage: boolean, startCursor?: string | null } } | null };


export const AllInvoicesDocument = gql`
    query allInvoices($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $customer: Float, $text: String) {
  allInvoices(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    text: $text
    customer: $customer
  ) {
    edges {
      cursor
      node {
        id
        customerName
        phone
        currency
        vatRate
        vatPrice
        vatIndexPriceDiff
        idAsString
        totalPrice
        notes
        chargedIndex
        chargeDate
        baseRentalPrice
        baseLicenceAndInsurancePrice
        baseMaintenancePrice
        dealIds
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useAllInvoicesQuery__
 *
 * To run a query within a React component, call `useAllInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInvoicesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      customer: // value for 'customer'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAllInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<AllInvoicesQuery, AllInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllInvoicesQuery, AllInvoicesQueryVariables>(AllInvoicesDocument, options);
      }
export function useAllInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllInvoicesQuery, AllInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllInvoicesQuery, AllInvoicesQueryVariables>(AllInvoicesDocument, options);
        }
export type AllInvoicesQueryHookResult = ReturnType<typeof useAllInvoicesQuery>;
export type AllInvoicesLazyQueryHookResult = ReturnType<typeof useAllInvoicesLazyQuery>;
export type AllInvoicesQueryResult = Apollo.QueryResult<AllInvoicesQuery, AllInvoicesQueryVariables>;